!(function () {
  'use strict';
  var e = {};
  e.g = (function () {
    if ('object' == typeof globalThis) return globalThis;
    try {
      return this || new Function('return this')();
    } catch (e) {
      if ('object' == typeof window) return window;
    }
  })();
  const t =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    { fetch: s } = e.g;
  class r extends HTMLElement {
    constructor() {
      (super(),
        (this.listId = KLAVIYO_LIST_ID),
        (this.form = this.querySelector('.newsletter-form')),
        (this.forms = [...this.querySelectorAll('form')]),
        this.forms.forEach((e) => {
          e.addEventListener('submit', this.onSubmit);
        }));
    }
    destroy = () => {
      this.form.removeEventListener('submit', this.onSubmit);
    };
    onSubmit = (e) => {
      e.preventDefault();
      let r = e.target.querySelector('input[name="email"]'),
        sourceInput = e.target.querySelector('input[name="source"]') || e.target.querySelector('input[name="$source"]'),
        rawSource = sourceInput && sourceInput.value.trim() ? sourceInput.value.trim() : '',
        signupSource = rawSource.toLowerCase().includes('navbar') ? 'Navbar Newsletter' : 'Footer Newsletter',
        o = (e.target.querySelector('.newsletter-form-success'), e.target.querySelector('.error'));
      (o.querySelector('span'),
        console.log('emailError:'),
        console.log(o),
        e.preventDefault(),
        t.test(r.value)
          ? (function (e, t, src) {
              let r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
                o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 'Both';
              const fields = ['Interests', '$source'];
              const i = Object.assign(
                {},
                r,
                {
                  g: e,
                  email: t,
                  $fields: fields.join(','),
                  Interests: o,
                  $source: src,
                }
              ),
                a = Object.keys(i).reduce((e, t) => (e.append(t, i[t]), e), new URLSearchParams());
              return s('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
                method: 'POST',
                headers: {
                  'Access-Control-Allow-Headers': '*',
                  'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
                },
                body: a,
              }).then((e) => e.json());
            })(this.listId, r.value, signupSource)
              .then((e) => {
                const isFr = document.documentElement.lang === 'fr' || window.location.pathname.includes('/fr');
                e.success
                  ? (o.classList.remove('active'), (r.value = isFr ? "Merci ! Vous êtes inscrit(e)." : "Thanks! You're signed up."), (r.placeholder = ''))
                  : (o.classList.add('active'),
                    console.log(e),
                    console.log('error'),
                    setTimeout(() => {
                      (o.classList.remove('active'), (r.value = ''));
                    }, 3e3));
              })
              .catch((e) => {
                const isFr = document.documentElement.lang === 'fr' || window.location.pathname.includes('/fr');
                (console.log(e),
                  r.classList.add('active'),
                  (r.value = ''),
                  setTimeout(() => {
                    (o.classList.remove('active'), (r.value = ''));
                  }, 3e3),
                  alert(isFr ? 'Une erreur est survenue. Veuillez réessayer plus tard.' : 'An error occured. Please try again later.'));
              })
          : o.classList.add('active'));
    };
  }
  customElements.define('klaviyo-form', r);
})();
